import React from 'react';
import { CardSkeletonProps } from './types';
import './Card.css';

const CardSkeleton: React.FC<CardSkeletonProps> = ({
  variant = 'default',
  size = 'medium',
  showHeader = true,
  showContent = true,
  showFooter = false,
  lines = 3,
  className = '',
  sx = {},
}) => {
  const cardClasses = [
    'raith-card',
    `raith-card--${variant}`,
    `raith-card--${size}`,
    'raith-card--loading',
    className
  ].filter(Boolean).join(' ');

  const renderSkeletonLines = (count: number) => {
    return Array.from({ length: count }, (_, index) => {
      let lineClass = 'raith-card__skeleton-line';
      
      // Vary line widths for more realistic skeleton
      if (index === 0) {
        lineClass += ' raith-card__skeleton-line--long';
      } else if (index === count - 1) {
        lineClass += ' raith-card__skeleton-line--short';
      } else {
        lineClass += ' raith-card__skeleton-line--medium';
      }

      return (
        <div
          key={index}
          className={`${lineClass} raith-card__skeleton`}
        />
      );
    });
  };

  return (
    <div className={cardClasses} style={sx}>
      {showHeader && (
        <div className={`raith-card__header ${size === 'compact' ? 'raith-card__header--compact' : ''}`}>
          <div className="raith-card__header-content">
            <div className={`raith-card__skeleton-avatar ${size === 'compact' ? 'raith-card__skeleton-avatar--compact' : ''} raith-card__skeleton`} />
            <div className="raith-card__header-text">
              <div className="raith-card__skeleton-line raith-card__skeleton-line--title raith-card__skeleton" />
              <div className="raith-card__skeleton-line raith-card__skeleton-line--subtitle raith-card__skeleton" />
            </div>
          </div>
          <div className="raith-card__action">
            <div className="raith-card__skeleton-line raith-card__skeleton" style={{ width: '24px', height: '24px' }} />
          </div>
        </div>
      )}

      {showContent && (
        <div className={`raith-card__content ${size === 'compact' ? 'raith-card__content--compact' : ''}`}>
          {renderSkeletonLines(lines)}
        </div>
      )}

      {showFooter && (
        <div className={`raith-card__footer ${size === 'compact' ? 'raith-card__footer--compact' : ''}`}>
          <div className="raith-card__footer-actions">
            <div className="raith-card__skeleton-line raith-card__skeleton" style={{ width: '60px', height: '32px' }} />
            <div className="raith-card__skeleton-line raith-card__skeleton" style={{ width: '60px', height: '32px' }} />
          </div>
          <div className="raith-card__footer-metadata">
            <div className="raith-card__skeleton-line raith-card__skeleton" style={{ width: '80px', height: '12px' }} />
          </div>
        </div>
      )}
    </div>
  );
};

export default CardSkeleton;